import Component from '@bythepixel/component-loader';

export default class UseMyLocation extends Component {
  static selector = '[comp-dealer-locator-use-location]';

  constructor(...args) {
    super(...args);
    this.events();
  }

  events() {
    this.$container.addEventListener('click', () => {
      const lat = window.CIMARRON?.userLocation?.lat;
      const lng = window.CIMARRON?.userLocation?.lng;

      if (lat && lng) {
        document.dispatchEvent(new CustomEvent('dealer-locator:sort-by-location', {
          detail: { lat: parseFloat(lat), lng: parseFloat(lng) },
        }));
      }
    });
  }
}
